module.exports = __webpack_public_path__ + "static/media/load.b660dd2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/load.svg
// module id = 353
// module chunks = 0